// Every results story page. The results hub and each story page link to
// this list, so each story has crawlable links from its siblings.
export const RESULTS_STORIES = [
  { name: "Brian Urlacher", href: "/results/brian-urlacher/" },
  { name: "Deion Sanders", href: "/results/deion-sanders/" },
  { name: "Zach Johnson", href: "/results/zach-johnson/" },
  { name: "Mike Bibby", href: "/results/mike-bibby/" },
  { name: "Pat Hoberg", href: "/results/pat-hoberg/" },
  { name: "Ian Happ", href: "/results/ian-happ/" },
  { name: "Jim Cornelison", href: "/results/jim-cornelison/" },
  { name: "Matt Forte", href: "/results/matt-forte/" },
  { name: "Bryan Bickell", href: "/results/bryan-bickell/" },
  { name: "Danny Kanell", href: "/results/danny-kanell/" },
  { name: "Heath Evans", href: "/results/heath-evans/" },
  { name: "Kevin Streelman", href: "/results/kevin-streelman/" },
  { name: "Kevin VanDam", href: "/results/kevin-vandam/" },
  { name: "Ryne Sandberg", href: "/results/ryne-sandberg/" },
  { name: "Robert L.", href: "/results/robert-l/" },
];
